import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';

import { SeoProps } from './models';

const Seo: FC<SeoProps> = ({ description, lang, keywords, title }) => {
  const { siteSettings, brandSettings } = useStaticQuery(graphql`
    query SettingsQuery {
      siteSettings {
        siteName
        lang
      }
      brandSettings {
        brandName
      }
    }
  `);

  const siteTitle = siteSettings.siteName || '';
  const titleTemplate = title === siteTitle ? '%s' : `%s | ${siteTitle}`;
  const siteAuthor = brandSettings.brandName;
  const siteLang = lang || siteSettings.lang;
  const meta = [
    {
      name: 'description',
      content: description,
    },
    {
      property: 'og:title',
      content: title,
    },
    {
      property: 'og:description',
      content: description,
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary',
    },
    {
      name: 'twitter:creator',
      content: siteAuthor,
    },
    {
      name: 'twitter:title',
      content: title,
    },
    {
      name: 'twitter:description',
      content: description,
    },
    ...(keywords?.length
      ? [
          {
            name: 'keywords',
            content: keywords.join(', '),
          },
        ]
      : []),
  ];

  return <Helmet htmlAttributes={{ lang: siteLang }} {...{ title, titleTemplate, meta }} />;
};

export default Seo;
